import type { ReactNode } from 'react'

export interface SchedulingSection {
    id: string
    label: string
    icon: ReactNode
}

interface SchedulingSectionNavProps {
    sections: SchedulingSection[]
    /** Id da seção em foco, calculado por `IntersectionObserver` na página. */
    activeSection: string
}

/**
 * Índice lateral do formulário.
 *
 * É âncora, não aba: o conteúdo continua inteiro na página porque o operador
 * precisa ver item e valor ao mesmo tempo, e a validação desta tela é por toast
 * (nada trava se um campo estiver fora de vista).
 */
export default function SchedulingSectionNav({
    sections,
    activeSection,
}: SchedulingSectionNavProps) {
    return (
        <nav
            aria-label="Seções do formulário"
            className="hidden lg:sticky lg:top-16 lg:flex lg:flex-col lg:gap-1"
        >
            {sections.map(section => {
                const active = activeSection === section.id
                return (
                    <button
                        key={section.id}
                        type="button"
                        onClick={() =>
                            document.getElementById(section.id)?.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start',
                            })
                        }
                        className={`flex items-center gap-3 rounded-xl border px-3 py-2.5 text-left transition-colors ${
                            active
                                ? 'border-secondary/30 bg-secondary/10'
                                : 'border-transparent hover:bg-base-200'
                        }`}
                    >
                        <span
                            className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg transition-colors ${
                                active
                                    ? 'bg-secondary text-secondary-content'
                                    : 'bg-base-200 text-base-content/40'
                            }`}
                        >
                            {section.icon}
                        </span>
                        <span
                            className={`truncate text-sm ${
                                active
                                    ? 'font-semibold text-base-content'
                                    : 'text-base-content/60'
                            }`}
                        >
                            {section.label}
                        </span>
                    </button>
                )
            })}
        </nav>
    )
}
